angular.module("Main").factory("ShopService", ["$http", "$q", "NODEBACKEND", "SessionCache","SessionService",
    function ($http, $q, NODEBACKEND, SessionCache, SessionService) {
        var settings = null;
        var cycleUnits = [
            ["T_Tag", "T_Tage", "T_täglich"],
            ["T_Woche", "T_Wochen", "T_wöchentlich"],
            ["T_Monat", "T_Monate", "T_monatlich"],
            ["T_Jahr", "T_Jahre", "T_jährlich"]
        ];
        var cachedData = {
            customerData: {}
        };

        return {
            checkArtikelLinkConfig: checkArtikelLinkConfig,
            createShopBooking: createShopBooking,
            startShopPaymentPayPal: startShopPaymentPayPal,
            checkStatus: checkStatus,
            saveMVBooking: saveMVBooking,
            getOnlineShopConfiguration: getOnlineShopConfiguration,
            checkMvPrice: checkMvPrice,
            checkMvPrices: checkMvPrices,
            getUserDataByRIDForConfirm: getUserDataByRIDForConfirm,
            capturePaymentPayPal: capturePaymentPayPal,
            cancelBooking: cancelBooking
        };


        function checkArtikelLinkConfig(id) {
            return $http.get(NODEBACKEND + "/booking/shop/get/" + id).then(function (response) {
                return response.data;
            })
        }

        function createShopBooking(shopData) {
            let data = {Artikel: shopData}
            return $http.post(NODEBACKEND + "/booking/shop/create", data).then(function (response) {
                return response.data;
            });

        }

        function checkStatus(id) {
            return $http.get(NODEBACKEND + "/booking/shop/status/get/" + id).then(function (response) {
                return response.data;
            });
        }

        function startShopPaymentPayPal(shopData) {
            shopData.clubId = SessionService.getAuthData();
            let data = {Artikel: shopData}
            return $http.post(NODEBACKEND + "/shopPayPal/start", data).then(function (response) {
                return response.data;
            })
        }

        function saveMVBooking(orderId, lang) {
            return $http.get(NODEBACKEND + "/payment/shop/mv/booking/" + orderId + "/" + lang).then(function (response) {
                return response.data;
            })
        }

        function getOnlineShopConfiguration() {
            return $http.get(NODEBACKEND + "/booking/shop/configuration/get").then(function (response) {
                return response.data;
            });
        }

        function checkMvPrice(articleNr, personNr) {
            let data = {ArtikelNr: articleNr, PersonNr: personNr};
            return $http.post(NODEBACKEND + "/booking/shop/get/mv/price", data).then(function (response) {
                return response.data;
            })
        }

        function checkMvPrices(articleNrs, personNr) {
            let data = {ArtikelNrs: articleNrs, PersonNr: personNr};
            return $http.post(NODEBACKEND + "/booking/shop/get/mv/prices", data).then(function (response) {
                return response.data;
            })

        }

        function getUserDataByRIDForConfirm(rid) {
            var data = {rid: rid};
            return $http.post(NODEBACKEND + "/onlinebooking/getuserbyrid/shop", data).then(function (response) {
                return response.data;
            })
        }

        function capturePaymentPayPal(id) {
            let data = {OrderId: id};
            return $http.post(NODEBACKEND + "/shopPayPal/capture", data).then(function (response) {
                return response.data;
            })
        }

        function cancelBooking(orderId, lang, status) {
            return $http.post(NODEBACKEND + "/booking/shop/cancel", {orderId: orderId, lang: lang, status: status});
        }
    }]);